import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import UploadPage from './pages/UploadPage';
import ResultsPage from './pages/ResultsPage';
import ConfigPage from './pages/ConfigPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="content">
          <Routes>
            <Route path="/" element={<UploadPage />} />
            <Route path="/results/:jobId" element={<ResultsPage />} />
            <Route path="/configs" element={<ConfigPage />} />
          </Routes>
        </main>
        <footer className="footer">
          <div className="footer-content">
            <p>© {new Date().getFullYear()} EWS Analysis Tool</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
